"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var antd_1 = require("antd");
var Option = antd_1.Select.Option;
var LocaleWrapper_1 = require("../../LocaleWrapper/LocaleWrapper");
var en_US_1 = __importDefault(require("../../../locale/en_US"));
require("./IconSelector.css");
var _isEqual = require('lodash/isEqual');
var IconSelector = /** @class */ (function (_super) {
    __extends(IconSelector, _super);
    function IconSelector(props) {
        var _this = _super.call(this, props) || this;
        _this.libChange = function (value) {
            _this.setState({
                selectedLibIndex: value
            });
        };
        _this.getGallery = function (icon, index) {
            var _a = _this.state, selectedLibIndex = _a.selectedLibIndex, selectedIcon = _a.selectedIcon;
            var onIconSelect = _this.props.onIconSelect;
            var gridClassName = 'gs-icon-selector-grid';
            if (selectedIcon && selectedIcon.libIndex === selectedLibIndex && selectedIcon.iconIndex === index) {
                gridClassName += ' gs-icon-selector-grid-selected';
            }
            return (
            // @ts-ignore
            React.createElement(antd_1.Card.Grid, { key: index.toString(), className: gridClassName, onClick: function () {
                    if (onIconSelect) {
                        onIconSelect(icon.src);
                    }
                } },
                React.createElement(antd_1.Avatar, { className: "gs-icon-selector-grid-avatar", size: "default", src: icon.src, alt: icon.caption, shape: "square" }),
                React.createElement(antd_1.Card.Meta, { className: "gs-icon-selector-grid-description", description: icon.caption })));
        };
        var selection = {};
        if (props.selectedIconSrc) {
            selection = IconSelector.getSelectedIconFromSrc(props.selectedIconSrc, props.iconLibraries);
        }
        _this.state = {
            selectedLibIndex: selection.libIndex || 0
        };
        return _this;
    }
    IconSelector.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        var diffProps = !_isEqual(this.props, nextProps);
        var diffState = !_isEqual(this.state, nextState);
        return diffProps || diffState;
    };
    IconSelector.getDerivedStateFromProps = function (props, state) {
        if (props.selectedIconSrc) {
            var selection = IconSelector.getSelectedIconFromSrc(props.selectedIconSrc, props.iconLibraries);
            return {
                selectedIcon: selection,
                selectedLibIndex: state.selectedLibIndex
            };
        }
        else {
            return {
                selectedLibIndex: state.selectedLibIndex
            };
        }
    };
    IconSelector.getSelectedIconFromSrc = function (src, iconLibraries) {
        var libIndex;
        var iconIndex;
        var found = false;
        for (var i = 0; i < iconLibraries.length; i++) {
            var lib = iconLibraries[i];
            if (found) {
                break;
            }
            for (var j = 0; j < lib.icons.length; j++) {
                var icon = lib.icons[j];
                if (icon.src === src) {
                    libIndex = i;
                    iconIndex = j;
                    found = true;
                    break;
                }
            }
        }
        return {
            libIndex: libIndex,
            iconIndex: iconIndex
        };
    };
    IconSelector.prototype.render = function () {
        var _this = this;
        var _a = this.props, locale = _a.locale, iconLibraries = _a.iconLibraries;
        var selectedLibIndex = this.state.selectedLibIndex;
        return (React.createElement("div", { className: "gs-icon-selector" },
            React.createElement("div", { className: "gs-lib-row" },
                React.createElement("span", { className: "gs-label" }, locale.librarySelectLabel + ":"),
                React.createElement(antd_1.Select, { className: "gs-select", allowClear: false, defaultValue: selectedLibIndex, onChange: this.libChange }, iconLibraries.map(function (lib, index) {
                    return (React.createElement(Option, { value: index, key: index.toString() }, lib.name));
                }))),
            React.createElement(antd_1.Card, { className: "gs-icon-selector-card" }, iconLibraries[selectedLibIndex].icons.map(function (icon, index) {
                return _this.getGallery(icon, index);
            }))));
    };
    IconSelector.defaultProps = {
        locale: en_US_1.default.GsIconSelector
    };
    IconSelector.componentName = 'IconSelector';
    return IconSelector;
}(React.Component));
exports.IconSelector = IconSelector;
exports.default = LocaleWrapper_1.localize(IconSelector, IconSelector.componentName);
//# sourceMappingURL=IconSelector.js.map